<div class="spin-wheel-container">
  <button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="dialog-header">
    <div class="header-title-row">
      <span class="sparkle left">✦</span>
      <div class="gift-icon-wrapper">
        <svg
          width="46"
          height="46"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M40 20H8V40C8 42.2091 9.79086 44 12 44H36C38.2091 44 40 42.2091 40 40V20Z"
            fill="#F97316" />
          <path
            d="M42 12H6C4.89543 12 4 12.8954 4 14V18C4 19.1046 4.89543 20 6 20H42C43.1046 20 44 19.1046 44 18V14C44 12.8954 43.1046 12 42 12Z"
            fill="#FB923C" />
          <path d="M26 12V44H22V12H26Z" fill="#FEF08A" />
          <path
            d="M17.5 12C15.0147 12 13 9.98528 13 7.5C13 5.01472 15.0147 3 17.5 3C21 3 24 8 24 12H17.5Z"
            fill="#FB923C" />
          <path
            d="M30.5 12C32.9853 12 35 9.98528 35 7.5C35 5.01472 32.9853 3 30.5 3C27 3 24 8 24 12H30.5Z"
            fill="#FB923C" />
        </svg>
      </div>
      <div class="title-text-box">
        <h2 class="title-main">{{ campaign?.campaignName || 'Spin & Win' }}</h2>
        <!-- <h3 class="title-sub">Exclusive Rewards!</h3> -->
      </div>
      <span class="sparkle right">✦</span>
    </div>
    <p class="subtitle">
      {{ campaign?.description || 'Spin the wheel to unlock special discounts for your order' }}
    </p>
  </div>

  <div class="wheel-wrapper">
    <!-- Top Pointer Pin -->
    <div class="pointer-wrapper">
      <svg width="34" height="42" viewBox="0 0 34 42" fill="none">
        <path
          d="M17 42C17 42 34 26.5 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.5 17 42 17 42Z"
          fill="#EA580C" />
        <circle cx="17" cy="15" r="6" fill="#FFFFFF" />
      </svg>
    </div>

    <div class="wheel-outer">
      <svg
        class="wheel-svg"
        viewBox="0 0 300 300"
        [style.transform]="'rotate(' + rotationDegree + 'deg)'"
        [class.spinning]="isSpinning">
        <!-- Wheel Slices -->
        <g *ngFor="let reward of rewards; let i = index">
          <path
            [attr.d]="getSVGPath(i)"
            [attr.fill]="reward.color"
            stroke="#FFFFFF"
            stroke-width="2.5" />
        </g>

        <!-- Upright Text & Icons for Each Slice (Rotated Counter to Wheel Spin Angle to stay completely horizontal/upright) -->
        <g
          *ngFor="let reward of rewards; let i = index"
          [attr.transform]="
            'translate(' + getContentCenter(i).x + ', ' + getContentCenter(i).y + ')'
          ">
          <g [attr.transform]="'rotate(-' + rotationDegree + ')'">
            <!-- Icons (Properly sized and vertically spaced above text) -->
            <svg
              *ngIf="reward.icon === 'tag'"
              x="-9"
              [attr.y]="reward.subLabel ? -29 : -24"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M12.59 2.59A2 2 0 0 0 11.17 2H4a2 2 0 0 0-2 2v7.17a2 2 0 0 0 .59 1.41l9 9a2 2 0 0 0 2.83 0l7.17-7.17a2 2 0 0 0 0-2.83l-9-9z"
                fill="#FFFFFF" />
              <circle cx="6.5" cy="6.5" r="1.5" stroke="#FFFFFF" stroke-width="0.5" fill="none" />
            </svg>

            <svg
              *ngIf="reward.icon === 'truck'"
              x="-9"
              [attr.y]="reward.subLabel ? -29 : -24"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none">
              <path d="M1 3h15v13H1zM16 8h4l3 3v5h-7z" fill="#FFFFFF" />
              <circle cx="5.5" cy="18.5" r="2.5" fill="#FFFFFF" />
              <circle cx="18.5" cy="18.5" r="2.5" fill="#FFFFFF" />
            </svg>

            <svg
              *ngIf="reward.icon === 'refresh'"
              x="-9"
              [attr.y]="reward.subLabel ? -29 : -24"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none">
              <path
                d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.3"
                stroke="#FFFFFF"
                stroke-width="2.5"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>

            <svg
              *ngIf="reward.icon === 'gift'"
              x="-9"
              [attr.y]="reward.subLabel ? -29 : -24"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none">
              <path d="M20 12v10H4V12" stroke="#FFFFFF" stroke-width="2" fill="none" />
              <path d="M2 7h20v5H2z" fill="#FFFFFF" />
              <path d="M12 22V7" stroke="#FFFFFF" stroke-width="2" />
              <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" fill="#FFFFFF" />
              <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" fill="#FFFFFF" />
            </svg>

            <svg
              *ngIf="reward.icon === 'percent'"
              x="-9"
              [attr.y]="reward.subLabel ? -29 : -24"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none">
              <line
                x1="19"
                y1="5"
                x2="5"
                y2="19"
                stroke="#FFFFFF"
                stroke-width="2.5"
                stroke-linecap="round" />
              <circle cx="6.5" cy="6.5" r="2.5" fill="#FFFFFF" />
              <circle cx="17.5" cy="17.5" r="2.5" fill="#FFFFFF" />
            </svg>

            <!-- Text Labels (Strictly Upright & Clearly Separated) -->
            <text
              x="0"
              [attr.y]="reward.subLabel ? 0 : 6"
              fill="#FFFFFF"
              [attr.font-size]="reward.subLabel ? '10' : '11'"
              font-weight="900"
              text-anchor="middle">
              {{ reward.label }}
            </text>
            <text
              *ngIf="reward.subLabel"
              x="0"
              y="12"
              fill="#FFFFFF"
              font-size="9"
              font-weight="800"
              text-anchor="middle">
              {{ reward.subLabel }}
            </text>
          </g>
        </g>

        <!-- Outer Ring Rim Dots -->
        <g *ngFor="let reward of rewards; let i = index">
          <circle
            [attr.cx]="getDotCoordinates(i).x"
            [attr.cy]="getDotCoordinates(i).y"
            r="4.5"
            fill="#FFFFFF"
            stroke="#FED7AA"
            stroke-width="1.5" />
        </g>
      </svg>

      <!-- Center SPIN Button -->
      <div class="center-cap" [class.disabled]="alreadyUsed" (click)="spin()">
        <span class="spin-text">{{ alreadyUsed ? 'DONE' : 'SPIN' }}</span>
      </div>
    </div>
  </div>

  <div class="action-section">
    <!-- Already Used Banner -->
    <div *ngIf="alreadyUsed && !hasSpun" class="pre-spin-card">
      <div class="pre-spin-box">
        <div class="glow-badge">✨ SPINS USED</div>
        <p class="pre-spin-text">
          You have used your spin for the current period. Check back later for more rewards!
        </p>
      </div>

      <button class="continue-btn" (click)="close()">
        <span>CONTINUE SHOPPING</span>
      </button>
    </div>

    <!-- Pre-spin prompt banner -->
    <div *ngIf="!alreadyUsed && !hasSpun" class="pre-spin-card">
      <div class="pre-spin-box">
        <div class="glow-badge">🎁 TODAY'S SPECIAL</div>
        <p class="pre-spin-text">
          Tap <strong>SPIN</strong> on the wheel or the button below to test your luck!
        </p>
      </div>

      <button class="continue-btn spin-now-btn" [disabled]="isSpinning" (click)="spin()">
        <span *ngIf="!isSpinning">🎯 SPIN THE WHEEL NOW</span>
        <span *ngIf="isSpinning">🌀 SPINNING THE WHEEL...</span>
      </button>
    </div>

    <!-- Animated Result Card -->
    <div *ngIf="hasSpun" class="result-card show">
      <!-- Winning Outcome -->
      <div *ngIf="wonReward && !wonReward.isLoss" class="result-box win animated-bounce">
        <div class="confetti-sparks">
          <span class="spark s1">✨</span>
          <span class="spark s2">🎉</span>
          <span class="spark s3">✨</span>
        </div>
        <div class="congrats-row">
          <span class="congrats-text">{{ wonReward.resultTitle || 'Congratulations!' }}</span>
        </div>
        <p class="you-won-text">{{ wonReward.resultSubtitle || 'You won' }}</p>
        <div class="winning-amount pulse-glow">
          {{ wonReward.discount }}
        </div>
        <p *ngIf="wonReward.resultMessage" class="result-detail-text">
          {{ wonReward.resultMessage }}
        </p>

        <div *ngIf="wonReward.code" class="coupon-code-pill" (click)="copyCode(wonReward.code)">
          <span class="code-text">{{ wonReward.code }}</span>
          <span class="copy-hint">{{ copied ? 'COPIED!' : 'TAP TO COPY' }}</span>
        </div>
      </div>

      <!-- Better Luck / Loss Outcome -->
      <div *ngIf="wonReward && wonReward.isLoss" class="result-box loss animated-bounce">
        <div class="loss-icon-badge">
          <span>🍀</span>
        </div>
        <div class="congrats-row loss">
          <span class="congrats-text loss">{{
            wonReward.resultTitle || 'Better Luck Next Time!'
          }}</span>
        </div>
        <p class="you-won-text loss">{{ wonReward.resultSubtitle || "Don't give up!" }}</p>
        <div class="winning-amount loss-text">
          {{ wonReward.discount }}
        </div>
        <p class="result-detail-text loss">
          {{ wonReward.resultMessage || 'Check back in the next period to test your luck again!' }}
        </p>
      </div>

      <button class="continue-btn" (click)="close()">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0"></path>
        </svg>
        <span>CONTINUE SHOPPING</span>
      </button>
    </div>
  </div>
</div>
